<template>
	<div>
		<div class="clear"></div>
		<!--底部 开始-->
		<div class="footer-menu">
			<div class="w1200 bc clearfix" style="min-height:100px;">
		    	<ul class="cols-1">
		    		<li><a href="javasctipt:;" style="font-weight: 900;color: #666;">{{frendlinkList.name}}</a></li>
		        	<li v-for="frendlink in frendlinkList.list"><a :href="frendlink.url">{{frendlink.title}}</a></li>
		            <!--<li><a href="#">恒生电子</a></li>
		            <li><a href="#">恒生云永</a></li>-->
		        </ul>
		        <ul class="cols-2">
		        	<li><a href="javasctipt:;" style="font-weight: 900;color: #666;">{{paymentList.name}}</a></li>
		        	<li v-for="payment in paymentList.list"><a :href="payment.url">{{payment.title}}</a></li>
		            <!--<li><a href="#">支付方式</a></li>
		            <li><a href="#">配送方式</a></li>
		            <li><a href="#">发票说明</a></li>-->
		        </ul>
		        <ul class="cols-3">
		        	<li><a href="javasctipt:;" style="font-weight: 900;color: #666;">{{serviceList.name}}</a></li>
		            <!--<li><a href="#">退换货规则</a></li>
		            <li><a href="#">售后服务保障</a></li>-->
		            <li v-for="service in serviceList.list"><a :href="service.url">{{service.title}}</a></li>
		        </ul>
		    </div>
		</div>
	</div>
</template>

<script>
	import {getCmsUrl,cmsApiUrl} from "../../static/js/emallUtils.js"
	export default {
		name: 'footermenu',
		data() {
			return {
				cmsApiUrl:'',
				serviceList:{'name':'',list:[]},
				paymentList:{'name':'',list:[]},
//				aboutusList:[],
				frendlinkList:{'name':'',list:[]}
			}
		},
		methods:{
			requestCms:function(req_param){
			var that = this;
			var params = {
				c:req_param
			};
			jQuery.ajax({
				type: "get",
				url:cmsApiUrl,
				async: false,
				dataType: "jsonp", // 返回的数据类型，设置为JSONP方式
				cache:true,
				data: params,
				success: function(ret) {
					if(ret.code == 'success') {
						var list = ret.values.list;
							if(req_param == "Service"){
								that.serviceList.name = ret.name;
							}else if(req_param == "Payment"){
								that.paymentList.name = ret.name;
							}else if(req_param == "frendlink"){
								that.frendlinkList.name = ret.name;
							}
						if(list != undefined && list.length > 0) {
							if(req_param == "Service"){
								that.serviceList.list = list;
								that.serviceList.name = ret.name;
							}else if(req_param == "Payment"){
								that.paymentList.list = list;
								that.paymentList.name = ret.name;
//							}else if(req_param == "aboutus"){
//								that.aboutusList = list;
							}else if(req_param == "frendlink"){
								that.frendlinkList.list = list;
								that.frendlinkList.name = ret.name;
							}
						}
					}
				},
				error: function(err) {

				}
			})
			}
		},
		mounted(){
			this.cmsApiUrl = getCmsUrl();
			this.requestCms("Service");
			this.requestCms("Payment");
//			this.requestCms("aboutus");
			this.requestCms("frendlink");

		}
		
			
		
		
		
	}
</script>



// WEBPACK FOOTER //
// src/components/FooterMenu.vue?0c2bc634